var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAtendimentoIniciado({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5756 8.45685C18.0754 8.13458 17.4952 7.96423 16.8976 7.96423H16.066C15.7424 7.96423 15.48 8.22658 15.48 8.55017V14.7748C15.48 15.0984 15.7424 15.3607 16.066 15.3607H16.8976C18.6083 15.3607 20 13.969 20 12.2583V11.0665C20 10.0067 19.4674 9.03103 18.5756 8.45685Z",
    fill: "#30D158"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7666 16.522H16.619C15.9817 17.7862 14.6714 18.6555 13.1617 18.6555C12.8381 18.6555 12.5758 18.9178 12.5758 19.2414C12.5758 19.565 12.8381 19.8273 13.1617 19.8273C15.3959 19.8273 17.2949 18.3662 17.9544 16.3495C17.5777 16.4616 17.1791 16.522 16.7666 16.522Z",
    fill: "#30D158"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10 0.172852C5.93953 0.172852 2.5593 3.13867 1.91028 7.01766C2.30661 6.88519 2.72278 6.81332 3.14621 6.80457C3.8618 3.68152 6.66305 1.34473 10 1.34473C13.3369 1.34473 16.1382 3.68152 16.8537 6.80461C17.2772 6.81336 17.6933 6.88523 18.0897 7.0177C17.4407 3.13867 14.0605 0.172852 10 0.172852Z",
    fill: "#30D158"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.93398 7.96423H3.10234C2.50473 7.96423 1.92453 8.13455 1.42465 8.45669C0.532578 9.03103 0 10.0067 0 11.0666V12.2584C0 13.969 1.39172 15.3607 3.10234 15.3607H3.93398C4.25758 15.3607 4.51992 15.0984 4.51992 14.7748V8.55017C4.51992 8.22658 4.25758 7.96423 3.93398 7.96423Z",
    fill: "#30D158"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAtendimentoIniciado);
export default __webpack_public_path__ + "static/media/atendimento-iniciado.4dc000b0.svg";
export { ForwardRef as ReactComponent };